import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled/stack';

import { LoadingSkeleton } from '@townsquare/loading-skeleton';

export const Skeleton = ({
	labelWidth,
	testId,
}: {
	labelWidth: string;
	testId: string;
}): React.JSX.Element => (
	<Stack testId={testId} space="space.050">
		<LoadingSkeleton width={labelWidth} height="14px" marginBottomPx={4} marginTopPx={4} />
		<LoadingSkeleton width="100%" height="40px" />
	</Stack>
);
